import React from 'react'
import { Provider } from 'react-redux'
import { Route, BrowserRouter, Routes } from 'react-router-dom'
import { AuthorizationContainer } from './components/Authorization'

class Root extends React.Component {

  render() {

    return (
      <Provider store={this.props.store}>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<AuthorizationContainer />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    )
  }
}

export default Root